import {Dispatch} from "redux";

import {catch400, catch403, postRequest, Response400} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {IApplicationData} from "../../application/types/IApplicationData";
import {IPostApplicationPayload} from "../../application/types/lead/IPostApplicationPayload";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {patchUserConsent} from "../../user/api/patch_user_consent";
import {MarketingConsentType} from "../../user/types/MarketingConsentType";

interface IPropertyConsultingOptions {
    on400Response?: (error: Response400) => void;
}

const applicationApiLink = apiPath.applications.create.base;

export const postFavouritesApplication =
    (jsonData: IPostApplicationPayload, options: IPropertyConsultingOptions = {}) =>
    async (_dispatch: Dispatch): Promise<IApplicationData | void> => {
        const payload = await appendTurnstileToken(jsonData, TurnstileAction.APPLICATION_CREATE);

        return postRequest({}, applicationApiLink, payload as unknown as Record<string, unknown>)
            .then((application: IApplicationData) => {
                const hasMktConsent = application.marketing_email || application.marketing_sms;

                if (application.user_created && hasMktConsent) {
                    patchUserConsent({[MarketingConsentType.PHONE]: application.marketing_sms, [MarketingConsentType.EMAIL]: application.marketing_email});
                }

                return application;
            })
            .catch(
                catch400((error) => {
                    options.on400Response && options.on400Response(error);
                })
            )
            .catch(
                catch403((error) => {
                    notifyBugsnag(error, "postRecommendedProperties: catch 403", error.responseError ?? {});
                })
            );
    };
import {Dispatch} from "redux";

import {catch400, catch403, postRequest, Response400} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {IApplicationData} from "../../application/types/IApplicationData";
import {IPostApplicationPayload} from "../../application/types/lead/IPostApplicationPayload";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {patchUserConsent} from "../../user/api/patch_user_consent";
import {MarketingConsentType} from "../../user/types/MarketingConsentType";

interface IPropertyConsultingOptions {
    on400Response?: (error: Response400) => void;
}

const applicationApiLink = apiPath.applications.create.base;

export const postFavouritesApplication =
    (jsonData: IPostApplicationPayload, options: IPropertyConsultingOptions = {}) =>
    async (_dispatch: Dispatch): Promise<IApplicationData | void> => {
        const payload = await appendTurnstileToken(jsonData, TurnstileAction.APPLICATION_CREATE);

        return postRequest({}, applicationApiLink, payload as unknown as Record<string, unknown>)
            .then((application: IApplicationData) => {
                const hasMktConsent = application.marketing_email || application.marketing_sms;

                if (application.user_created && hasMktConsent) {
                    patchUserConsent({[MarketingConsentType.PHONE]: application.marketing_sms, [MarketingConsentType.EMAIL]: application.marketing_email});
                }

                return application;
            })
            .catch(
                catch400((error) => {
                    options.on400Response && options.on400Response(error);
                })
            )
            .catch(
                catch403((error) => {
                    notifyBugsnag(error, "postRecommendedProperties: catch 403", error.responseError ?? {});
                })
            );
    };
